'use client';
import React, { useContext, useState, forwardRef } from 'react';
import languageContext from '@/context/language';
import dayjs from 'dayjs';
import { useTranslation } from '@/app/i18n/client';
import { SearchInput } from './search-input';
import { ResultsTable } from './results-table';
import { TableColumn } from '@/shared/components/Table/use-column';
import { useEventTracking } from '@/shared/tracking/use-tracking';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

const Certificates = forwardRef<HTMLInputElement>(function Certificates(props, ref) {
  const { lang } = useContext(languageContext);
  const { t } = useTranslation(lang, 'document-search');
  const [search, setSearch] = useState<string>();
  const [resetPageNo, setResetPageNumber] = useState<boolean>(false);
  const { trackEvent } = useEventTracking();
  const params = useSearchParams();
  const lotNumberParam = params.get('lotNumber')?.trim() || '';

  useEffect(() => {
    if (!lotNumberParam) return;
    setSearch(lotNumberParam);
    setResetPageNumber(true);
  }, [lotNumberParam]);

  const searchboxFunc = (key) => {
    setSearch(key);
    setResetPageNumber(true);
  };
  const setResetPage = (val) => {
    setResetPageNumber(val);
  };

  const columns: TableColumn<any>[] = [
    {
      accessorKey: 'lotNo',
      header: t('lot'),
      style: {
        minWidth: '200px',
      },
      cell: (row) => {
        return (
          <Link
            target="_blank"
            download
            href={row.lotNoUrl}
            className="flex"
            onClick={() => {
              trackEvent({
                key: 'eventsData',
                action: 'documentDownloaded',
                payload: {
                  event_name: 'documentDownloaded',
                  download_type: 'COA',
                  download_name: row.lotNo,
                  download_link: row.lotNoUrl,
                },
              });
            }}
          >
            <i className="icon-16-document-mono" />
            <p className="pl-2">{row.lotNo}</p>
          </Link>
        );
      },
    },
    {
      accessorKey: 'documentType',
      header: t('certificate.type'),
      style: {
        minWidth: '200px',
      },
    },
    {
      accessorKey: 'date',
      header: t('date'),
      style: {
        minWidth: '200px',
      },
      cell: (row) => {
        const dateVal = row.date;
        const date = dateVal ? dayjs(dateVal).format('DD MMM YYYY') : '';
        return date;
      },
    },
    {
      accessorKey: 'catalogNumberAndUrls',
      header: t('catalog.no'),
      style: {
        minWidth: '200px',
      },
      cell: (row) => {
        const catalogArr = row.catalogNumberAndUrls.map((catalog) => catalog.catalogNumber);
        return catalogArr.toString();
      },
    },
  ];

  return (
    <>
      <SearchInput placeHolderTxt={t('lot.placeholder')} onClick={searchboxFunc} initialValue={lotNumberParam} />
      <ResultsTable
        columns={columns}
        search={search}
        documentType="COA"
        resetPage={resetPageNo}
        setResetPage={setResetPage}
      />
    </>
  );
});

export { Certificates };
